export default "__VITE_ASSET__CT9Wa1x6__"